/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popJoin.vue?vue&type=template&id=59717e42&scoped=true"
import script from "./popJoin.vue?vue&type=script&lang=js"
export * from "./popJoin.vue?vue&type=script&lang=js"
import style0 from "./popJoin.vue?vue&type=style&index=0&id=59717e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59717e42",
  null
  
)

export default component.exports